import { render, staticRenderFns } from "./historyShop.vue?vue&type=template&id=c159359e&scoped=true&lang=true"
import script from "./historyShop.vue?vue&type=script&lang=js"
export * from "./historyShop.vue?vue&type=script&lang=js"
import style0 from "./historyShop.vue?vue&type=style&index=0&id=c159359e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c159359e",
  null
  
)

export default component.exports